import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Level1 from './level1';
import Level2 from './level2';
import RunBanner from '../needs_attention/month_run/run_banner';
import useActiveRun from '../needs_attention/month_run/use_active_run';
import { initial_l1_state } from './params';

/*
 * PROD-7828 R5 — Overview tab: L1 all-teacher table, L2 per-teacher breakdown.
 * Selection is cleared when the month changes so L2 never shows a teacher from another month. L1's filters, drafts
 * and page live here (D3), so Back from L2 lands on the same view; the digest's needs-review seed is read once.
 * D110: while a close/reopen run is active for the month, a banner shows its progress and links to it.
 */
const OverviewTab = ({
  pay_month,
  month_label,
  initial_needs_review,
  on_deep_link_consumed,
  on_open_needs_attention,
  on_open_penalties,
  on_error,
  on_notify
}) => {
  const location = useLocation();
  const active_run = useActiveRun(pay_month);
  const [selected, setSelected] = useState(null);
  const [l1_state, setL1State] = useState(() =>
    initial_l1_state(initial_needs_review, location.search)
  );

  useEffect(() => {
    if (on_deep_link_consumed) on_deep_link_consumed();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setSelected(null);
  }, [pay_month]);

  if (!pay_month) return null;
  const banner = <RunBanner run={active_run} on_open={on_open_needs_attention} />;
  if (selected) {
    return (
      <>
        {banner}
        <Level2
          pay_month={pay_month}
          month_label={month_label}
          teacher={selected}
          on_back={() => setSelected(null)}
          on_error={on_error}
          on_open_penalties={on_open_penalties}
        />
      </>
    );
  }
  return (
    <>
      {banner}
      <Level1
        pay_month={pay_month}
        month_label={month_label}
        view_state={l1_state}
        on_view_state={setL1State}
        on_error={on_error}
        on_notify={on_notify}
        on_open_teacher={setSelected}
      />
    </>
  );
};

export default OverviewTab;
